import {
  LOYALITY_DISCOUNT,
  COD_RESPONSE,
  RESET,
  LOYALITY_CARD_DATA,
} from './actions';

const initialState = {
  discount: '',
  codResponse: '',
  loyaltyCardData: '',
};

const CheckoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOYALITY_DISCOUNT:
      return Object.assign({}, state, {
        discount: action.data,
      });
    case COD_RESPONSE:
      return Object.assign({}, state, {
        codResponse: action.response,
      });

    case LOYALITY_CARD_DATA:
      return Object.assign({}, state, {
        loyaltyCardData: action.data,
      });
    case RESET:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

/* Selectors */
export const checkoutData = state => state.checkout;

// Export Reducer
export default CheckoutReducer;



// WEBPACK FOOTER //
// ./src/views/checkout/reducer.js